import { useState } from "react";
import { Link } from "react-router-dom";
import { MaskedLines, Reveal } from "../components/Reveal";
import { IndiaMap, MarketRows, ExtendedFootprint } from "../components/IndiaMap";
import { PRIORITY_MARKETS, ALL_MARKERS } from "../data/locations";

// Homepage priority-markets section — mirrors the profile site coverage layout:
// framed map with a floating selected-market card on the left, priority market
// rows on the right that drive the map on hover/focus while remaining real
// crawlable links to location pages, extended footprint chips below.
export function LocationsCompact() {
  const markets = ALL_MARKERS.filter((m) => PRIORITY_MARKETS.includes(m.id));
  const [active, setActive] = useState(ALL_MARKERS[0]);
  return (
    <section className="noise-dark relative overflow-hidden py-16 text-zinc-100 md:py-24" aria-label="Priority locations">
      <div className="absolute inset-0 grid-lines-dark" aria-hidden="true" />
      <div className="container-x relative">
        <Reveal>
          <p className="eyebrow-dark">09 / Priority markets</p>
        </Reveal>
        <MaskedLines
          as="h2"
          lines={["NATIONAL REACH.", "LOCALLY COORDINATED."]}
          accent={[0]}
          className="h-display mt-6 text-4xl text-zinc-50 sm:text-5xl lg:text-6xl"
        />

        <div className="mt-12 grid gap-10 lg:grid-cols-12 lg:gap-14" data-testid="home-markets-panel">
          {/* map with floating selected-market card */}
          <Reveal className="lg:col-span-7">
            <IndiaMap dark active={active} onActiveChange={setActive} placement="map_home" />
          </Reveal>

          {/* priority market rows + extended footprint */}
          <div className="lg:col-span-5">
            <MarketRows markets={markets} activeId={active.id} onHover={setActive} testidPrefix="home-market" />
            <ExtendedFootprint dark testid="home-extended-footprint" />
            <p className="mt-5 font-mono text-xs leading-relaxed tracking-[0.12em] text-zinc-400">
              1000+ clients served across India · 26 operating &amp; service markets. Property counts from DCC client records.
            </p>
            <Link to="/locations" data-testid="home-locations-all-link" className="link-tech mt-6 inline-flex text-zinc-200">
              Explore the full coverage map <span aria-hidden="true" className="text-dcc">→</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
